import React from "react";
import BackBtn from "../../Components/BackBtn/BackBtn";
import SelfCoachingItem from "./SelfCoachingItem/SelfCoachingItem";
import sportsData from "./sportsData";

export default function SelfCoaching() {
  return (
    <div className="gymBg bgContainer">
      <div className="blurOverlay">
        <div className="pageWrapper">
          <div className="pageHeader centeredFlex">
            <BackBtn />
          </div>
          <div className="pageTitle horizontalBorder">مربی خودت باش</div>
          <div style={{ marginTop: "1.25rem", width: "100%" }}>
            {sportsData.map((sport) => (
              <SelfCoachingItem key={sport.id} {...sport} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
